import { useStore } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';

// Toda gravação de tarefa feita pela interface passa por aqui. A action do
// store devolve { success: false } em vez de lançar, e quem chamava ignorava o
// retorno: o usuário achava que tinha salvo e a alteração se perdia.
export function useTaskActions() {
  const store = useStore();
  const { t } = useI18n();

  async function updateTask(payload) {
    const result = await store.dispatch('tasks/updateTask', payload);
    if (!result.success) useAlert(t('TASKS.ERRORS.UPDATE'));
    return result;
  }

  async function deleteTask(taskId) {
    try {
      await store.dispatch('tasks/deleteTask', taskId);
      return true;
    } catch (error) {
      const forbidden = [401, 403].includes(error.response?.status);
      useAlert(
        t(forbidden ? 'TASKS.ERRORS.DELETE_FORBIDDEN' : 'TASKS.ERRORS.DELETE')
      );
      return false;
    }
  }

  return { updateTask, deleteTask };
}
